import React from 'react';
import * as yup from 'yup';
import { Box, Grid, Typography } from '@mui/material';
import { useKeyObjectives } from 'hooks/EntityTypes/useKeyObjectives';
import { SparkForm, SparkFormAutoSubmitter } from 'sharedComponents/SparkForm';
import StepperBoxSkeleton from 'sharedComponents/Skeleton/StepperBoxSkeleton';
import EditKeyObjectiveFormContent from './EditKeyObjectiveFormContent';
import { KeyObjective } from 'types/entityTypes/KeyObjectives';

export type SettingsObjectiveFormValues = {
  objectiveIDs: string[];
  otherObjective: string;
};

const validationSchema = yup.object({
  objectiveIDs: yup.array(yup.string()).min(3).required(),
  otherObjective: yup
    .string()
    .test('requiredTest', 'Other Objective is Required', function test(value) {
      const isOtherIncluded =
        this?.options.context?.objectiveIDs?.includes('10');
      if (!isOtherIncluded) {
        return true;
      }
      if (!!value) {
        return true;
      }
      return false;
    }),
});
type SettingsObjectiveFormProps = {
  keyObjectives: KeyObjective[] | undefined;
  otherObjective: string | undefined;
  onSubmit: (values: SettingsObjectiveFormValues) => Promise<void>;
  categoryID: string | null | undefined;
};

function SettingsObjectiveForm({
  keyObjectives,
  otherObjective,
  categoryID,
  onSubmit,
}: SettingsObjectiveFormProps) {
  const {
    dropdownOptions: objectivesOptions,
    keyObjectivesIdByNameMap,
    isLoading,
  } = useKeyObjectives(categoryID);

  if (isLoading) {
    return <StepperBoxSkeleton />;
  }

  const initialValues = {
    objectiveIDs: keyObjectives?.map((objective) => objective.id) || [],
    otherObjective: otherObjective || '',
  };

  return (
    <Grid container>
      <Typography
        fontFamily='Mont-semibold'
        justifyContent='flex-start'
        sx={{ fontSize: '1.5rem', marginTop: '1rem', margin: '1rem 0' }}
      >
        Objectives
      </Typography>
      <Box
        width='100%'
        bgcolor='white'
        borderRadius='20px'
        border={(theme) => `1px solid ${theme.palette.borderColor}`}
      >
        <SparkForm
          initialValues={initialValues}
          validationSchema={validationSchema}
          enableReinitialize={true}
          onSave={onSubmit}
        >
          <Grid item padding={2} xs={12}>
            <Typography
              fontFamily='Mont-semibold'
              justifyContent='flex-start'
              sx={{ fontSize: '1.0rem' }}
              color='nightblack'
            >
              Select up to 3 key company objectives.
            </Typography>
          </Grid>
          <EditKeyObjectiveFormContent
            keyObjectivesIdByNameMap={keyObjectivesIdByNameMap}
            objectivesOptions={objectivesOptions}
          />
          <SparkFormAutoSubmitter />
        </SparkForm>
      </Box>
    </Grid>
  );
}

export default SettingsObjectiveForm;
